import { LoadingState, Skeleton } from '../common';

// Finances loading state — composed from the shared LoadingState + Skeleton
// primitives (same pulse blocks every other page uses). Reserves the page's
// shape — three stat tiles, the trend, the two-up row — so nothing jumps when
// the data lands.
export function FinancesSkeleton() {
  return (
    <LoadingState className="finances-loading" label="Loading finances…">
      <div className="finances-loading-stats">
        {[0, 1, 2, 3].map((i) => <Skeleton key={i} variant="stat" />)}
      </div>
      <Skeleton variant="chart" />
      <div className="finances-loading-grid">
        <Skeleton variant="chart" />
        <Skeleton variant="chart" />
      </div>
    </LoadingState>
  );
}
